import { useContext } from "react";
import { getIsTargetedPath } from "@/selectors";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { useOutboundPaths } from "../../links/useOutboundPaths";
import { CompanyContext } from "../CompanyList/CompanyContext";
import OutboundLink from "../general/OutboundLink";

export const BaseReviewLink = ({
	classNames,
	linkText,
	suffixIcon,
	prefixIcon,
}) => {
	const isTargetedPath = useSelector(getIsTargetedPath);
	if (isTargetedPath) return null;

	const { company } = useContext(CompanyContext);
	const { isCompanyReviewLinkable, companyReviewPath } = useOutboundPaths();
	if (!isCompanyReviewLinkable) return null;

	return (
		<OutboundLink
			to={companyReviewPath}
			company={company}
			className={classNames?.wrapper}
		>
			{prefixIcon}
			<span className={classNames?.text}>{linkText}</span>
			{suffixIcon}
		</OutboundLink>
	);
};

export default BaseReviewLink;

BaseReviewLink.propTypes = {
	classNames: PropTypes.object,
	linkText: PropTypes.string,
	suffixIcon: PropTypes.element,
	prefixIcon: PropTypes.element,
};
